import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getSiteContext } from '../../../state/contexts/site';
import { fetchAlarmDetails } from '../../../state/entities';
import { findAlarmDetails } from '../../../state/entities';
import { getAlarmUid, alarmCanBeResolved } from '../../../models';

import { useParamSelector, useCurrent } from '../../../helpers/hooks';

import AlarmView from './AlarmView';
import LoadWithSpinner from 'src/components/ui/Loading/LoadWithSpinner';
import MainModal from 'src/components/ui/MainModal';

import { PathBuilder } from '../../../routing';

export const AlarmDetailsLoader: React.FC<{ alarmId: string; alarmTagId: string }> = (props) => {
  const { alarmId, alarmTagId } = props;
  const site = useSelector(getSiteContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const { id: siteId } = site;

  const action = useCurrent(fetchAlarmDetails.request(siteId, alarmTagId, alarmId));

  useEffect(() => {
    if (action.current) {
      dispatch(action.current);
    }
  }, [action, alarmId, alarmTagId, dispatch, siteId]);

  const alarmDetails = useParamSelector(findAlarmDetails)(getAlarmUid({ alarmId, alarmTagId }));
  const modalContent = alarmDetails ? (
    <AlarmView siteId={siteId} alarmDetails={alarmDetails} />
  ) : (
    <LoadWithSpinner />
  );

  const onPrimaryAction = alarmDetails
    ? () =>
        history.push(PathBuilder.ALARM_ACK(siteId, alarmDetails.alarmId, alarmDetails.alarmTag.id))
    : undefined;
  const onSecondaryAction = alarmDetails
    ? () =>
        history.push(PathBuilder.ALARM_NOTE(siteId, alarmDetails.alarmId, alarmDetails.alarmTag.id))
    : undefined;
  const onTertiaryAction = alarmDetails
    ? () =>
        history.push(
          PathBuilder.ALARM_RESOLVE(siteId, alarmDetails.alarmId, alarmDetails.alarmTag.id)
        )
    : undefined;

  return (
    <MainModal
      height={550}
      isOpen
      onClose={() => history.push(PathBuilder.ALARMS_DEFAULT(siteId))}
      onPrimaryAction={onPrimaryAction}
      onSecondaryAction={onSecondaryAction}
      onTertiaryAction={onTertiaryAction}
      primaryButtonLabel="Acknowledge"
      secondaryButtonLabel="Add Note"
      tertiaryButtonLabel={alarmDetails && alarmCanBeResolved(alarmDetails) ? 'Resolve' : undefined}
      testId="alarm-details-modal"
      title="View Alarm"
      width={832}
      buttonTestId="alarm-ack-action"
      smallHeader
    >
      {modalContent}
    </MainModal>
  );
};
